module.exports = __webpack_public_path__ + "img/4-icono-enproceso.6a017ab5.svg";